import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6aa8761f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex flex-column flex-column-fluid flex-lg-row bgi-no-repeat",
  style: {"background-image":"url('/media/auth/bg4.jpg')","background-size":"100% 100%"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://edtrust.tn",
  class: "d-block d-lg-none mx-auto py-10"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "edtrust",
    src: "media/logos/edtrust.png",
    class: "theme-light-show h-150px"
  })
], -1))
const _hoisted_3 = { class: "d-flex flex-center w-lg-50 pt-10 pt-lg-0 px-10" }
const _hoisted_4 = { class: "card rounded-3 w-md-550px" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-center w-lg-50 p-10 logo\" data-v-6aa8761f><div class=\"d-flex flex-center flex-lg-start flex-column\" data-v-6aa8761f><a href=\"https://edtrust.tn\" class=\"d-none d-lg-block\" data-v-6aa8761f><img alt=\"Logo\" src=\"media/logos/edtrust.png\" class=\"h-250px\" data-v-6aa8761f></a><h2 class=\"text-gray-200 fw-bold d-none d-lg-block\" data-v-6aa8761f> Espace enseignant </h2></div></div>", 1)
const _hoisted_6 = { class: "footer py-4 d-flex flex-lg-column" }
const _hoisted_7 = { class: "d-flex flex-column flex-md-row align-items-center justify-content-between container-fluid" }
const _hoisted_8 = { class: "text-dark order-2 order-md-1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://edtrust.tn/",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/edtrust_logo.png",
    alt: "edtrust_logo",
    width: "30"
  })
], -1))
const _hoisted_10 = { class: "text-muted fw-bold me-1 fs-6" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://edtrust.tn/",
  target: "_blank",
  class: "text-gray-600 fw-bold fs-5 text-hover-primary"
}, "EdTrust", -1))
const _hoisted_12 = { class: "fw-bold order-1" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600 fs-5 fw-bolder mx-1" }, "EdTeacher - Espace enseignant", -1))
const _hoisted_14 = { class: "text-gray-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_view)
        ])
      ]),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, "Copyright © " + _toDisplayString(_ctx.moment().format("YYYY")) + " Tous Droits Réservés. ", 1),
          _hoisted_11
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("small", _hoisted_14, "Version: " + _toDisplayString(_ctx.appVersion), 1)
        ])
      ])
    ])
  ], 64))
}